export const industryTypeCategories = [
  { key: 'Agriculture', value: 'Agriculture' },
  { key: 'Automotive', value: 'Automotive' },
  { key: 'Defense', value: 'Defense' },
  { key: 'Design and Engineering', value: 'Design_And_Engineering' },
  { key: 'Digital Advertising', value: 'Digital_Advertising' },
  { key: 'Education', value: 'Education' },
  { key: 'Environmental Protection', value: 'Environmental_Protection' },
  { key: 'Financial Services', value: 'Financial_Services' },
  { key: 'Gaming', value: 'Gaming' },
  { key: 'General Public Services', value: 'General_Public_Services' },
  { key: 'Healthcare', value: 'Healthcare' },
  { key: 'Hospitality', value: 'Hospitality' },
  { key: 'InfoTech', value: 'InfoTech' },
  { key: 'Justice and Public Safety', value: 'Justice_And_Public_Safety' },
  { key: 'Life Sciences', value: 'Life_Sciences' },
  { key: 'Manufacturing', value: 'Manufacturing' },
  { key: 'Media & Entertainment', value: 'Media_Entertainment' },
  { key: 'Mining & Resources', value: 'Mining_Resources' },
  { key: 'Oil & Gas', value: 'Oil_Gas' },
  { key: 'Power & Utilities', value: 'Power_Utilities' },
  { key: 'Professional Services', value: 'Professional_Services' },
  { key: 'Real Estate & Construction', value: 'Real_Estate_Construction' },
  { key: 'Retail & Wholesale', value: 'Retail_Wholesale' },
  { key: 'Social Protection', value: 'Social_Protection' },
  { key: 'Telecommunications', value: 'Telecommunications' },
  {
    key: 'Travel, Transportation & Logistics',
    value: 'Travel_Transportation_Logistics',
  },
  { key: 'Other', value: 'Other' },
]

export const awsRegionsList = [
  { regionName: 'US East (Ohio)', region: 'us-east-2' },
  { regionName: 'US East (N. Virginia)', region: 'us-east-1' },
  { regionName: 'US West (N. California)', region: 'us-west-1' },
  { regionName: 'US West (Oregon)', region: 'us-west-2' },
  { regionName: 'Africa (Cape Town)', region: 'af-south-1' },
  { regionName: 'Asia Pacific (Hong Kong)', region: 'ap-east-1' },
  { regionName: 'Asia Pacific (Hyderabad)', region: 'ap-south-2' },
  { regionName: 'Asia Pacific (Jakarta)', region: 'ap-southeast-3' },
  { regionName: 'Asia Pacific (Melbourne)', region: 'ap-southeast-4' },
  { regionName: 'Asia Pacific (Mumbai)', region: 'ap-south-1' },
  { regionName: 'Asia Pacific (Osaka)', region: 'ap-northeast-3' },
  { regionName: 'Asia Pacific (Seoul)', region: 'ap-northeast-2' },
  { regionName: 'Asia Pacific (Singapore)', region: 'ap-southeast-1' },
  { regionName: 'Asia Pacific (Sydney)', region: 'ap-southeast-2' },
  { regionName: 'Asia Pacific (Thailand)', region: 'ap-southeast-7' },
  { regionName: 'Asia Pacific (Tokyo)', region: 'ap-northeast-1' },
  { regionName: 'Canada (Central)', region: 'ca-central-1' },
  { regionName: 'Canada West (Calgary)', region: 'ca-west-1' },
  { regionName: 'Europe (Frankfurt)', region: 'eu-central-1' },
  { regionName: 'Europe (Ireland)', region: 'eu-west-1' },
  { regionName: 'Europe (London)', region: 'eu-west-2' },
  { regionName: 'Europe (Milan)', region: 'eu-south-1' },
  { regionName: 'Europe (Paris)', region: 'eu-west-3' },
  { regionName: 'Europe (Spain)', region: 'eu-south-2' },
  { regionName: 'Europe (Stockholm)', region: 'eu-north-1' },
  { regionName: 'Europe (Zurich)', region: 'eu-central-2' },
  { regionName: 'Israel (Tel Aviv)', region: 'il-central-1' },
  { regionName: 'Mexico (Central)', region: 'mx-central-1' },
  { regionName: 'Middle East (Bahrain)', region: 'me-south-1' },
  { regionName: 'Middle East (UAE)', region: 'me-central-1' },
  { regionName: 'South America (São Paulo)', region: 'sa-east-1' },
  { regionName: 'AWS GovCloud (US-East)', region: 'us-gov-east-1' },
  { regionName: 'AWS GovCloud (US-West)', region: 'us-gov-west-1' },
]

export const markNotApplyReasons = [
  {
    value: 'OUT_OF_SCOPE',
    label: 'Out of scope',
  },
  {
    value: 'BUSINESS_PRIORITIES',
    label: 'Business priorities',
  },
  {
    value: 'ARCHITECTURE_CONSTRAINTS',
    label: 'Architecture constraints',
  },
  {
    value: 'OTHER',
    label: 'Other',
  },
  {
    value: 'NONE',
    label: 'None',
  },
]

export const shareWithOptions = [
  {
    value: 'CONNECTED_AWS_ACCOUNT',
    label: 'Connected Labra AWS Account',
  },
  {
    value: 'OTHER_AWS_ACCOUNT',
    label: 'External AWS Account',
  },
  {
    value: 'IAM_USERS',
    label: 'Specific IAM User(s)',
  },
]
